
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $ed4a047f249fb166$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"iVpKC\",\"definition-popup-content.10924151.js\",\"cyGuT\",\"feedback-collector.3c9dd1cd.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.7fa7fffd.js\",\"c4B8Z\",\"ai-feedback-flags.137115f6.js\",\"lb9xb\",\"smart-card.857a40f1.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.a88ed9b5.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"k031T\",\"visual-knowledge-card-empty-dark.4b1b4fc7.svg\",\"ffJt9\",\"visual-knowledge-card-empty-light.74a7204b.svg\",\"kBdy8\",\"visual-knowledge-card-error-dark.86770ffd.svg\",\"fqigh\",\"visual-knowledge-card-error-light.a73803d2.svg\",\"EfTik\",\"hoverCard.83d3f8c7.js\",\"eTYdV\",\"component-lazy.4e06d642.js\",\"l22f4\",\"CommentsPanelFooter.d0317e62.js\",\"ffEVr\",\"vendors~editor_icon.522dd127.js\",\"8l20h\",\"CommentsPanelFooter.095e8f29.js\",\"3GuOt\",\"GoalPanel.bfbc184b.js\",\"avPjX\",\"CommentEditor.c25022c9.js\",\"fx7pC\",\"CommentEditor.runtime.a7e4aaf7.js\",\"c251E\",\"CommentEditor.717ce66c.js\",\"3BYXV\",\"CommentEditor.runtime.f096591c.js\",\"cJv7L\",\"FullPageEditorComponent.8eeef261.js\",\"oKwJu\",\"FullPageEditorComponent.runtime.50b2a959.js\",\"gT8XU\",\"page-icon.527cfc33.js\",\"6wr18\",\"vendors~editor_icon.88037aa5.js\",\"gFEtJ\",\"blog-icon.ca697933.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.97f6cb8d.js\",\"iivLa\",\"blog.3e042e72.js\",\"dek7I\",\"page-live-doc.60bb3f45.js\",\"cSvhH\",\"FullPageEditorComponent.57fb463e.js\",\"3BYXV\",\"CommentEditor.runtime.f096591c.js\",\"fx7pC\",\"CommentEditor.runtime.a7e4aaf7.js\",\"oKwJu\",\"FullPageEditorComponent.runtime.50b2a959.js\",\"f8Ngf\",\"errorImageDark.0eb2b528.svg\",\"7o0Ks\",\"errorImageLight.5638c402.svg\",\"iraZ1\",\"react-markdown.bbf7a0fc.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9WCxa\",\"lumina.bd8e9e14.js\",\"lDdJi\",\"errorImageDark.0eb2b528.svg\",\"aJTjE\",\"errorImageLight.5638c402.svg\",\"j2vZ9\",\"liveReportingGraphic.3501d31a.svg\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\"]"));


$parcel$global.rlb("amnV8")
//# sourceMappingURL=definition-popup-content.runtime.97b5765c.js.map
